export const AnnounceState = {
    SAVE: '0',//保存
    APPROVAL: '2',//审核中
    PUBLISH: '1',//发布
    REVOCATION: '3'//撤回
}

/**
 * 跳转公告详情页面
 * @param announceId
 * @param state
 * @constructor
 */
export const ViewAnnounce = (announceId, state) => {
    let url = process.env.VUE_APP_API_SERVER + `/api/1/view/announce_info.html?announceId=${announceId}`
    //是否已发布
    if (state === AnnounceState.PUBLISH) {
        url = process.env.VUE_APP_WEB_ANNOUNCE_URL + announceId
    }
    window.open(url)
}

/**
 * 跳转需求调查项目详情页面
 * @param announceId
 * @param state
 * @constructor
 */
export const ViewDcAnnounce = (announceId, state) => {
    let url = process.env.VUE_APP_API_SERVER + `/api/1/view/demand_announce_info.html?announceId=${announceId}`
    //是否已发布
    if (state === AnnounceState.PUBLISH) {
        url = process.env.VUE_APP_WEB_DC_ANNOUNCE_URL + announceId
    }
    window.open(url)
}

export const DATE_PICKER_SET = {
    showTime: {
        minuteStep: 30
    },
    format: 'YYYY-MM-DD HH:mm'
}

/**
 * 根据采购方式返回字段名称
 */
export const methodTenderLabel = (cgfs) => {
    switch (cgfs) {
        case '12':
        case '14':
            return {
                bidFileEnd: '响应文件截止时间',
                openbidBegin: '谈判协商时间',
                openbidAddr: '谈判协商地点'
            }
        default:
            return {
                bidFileEnd: '投标文件截止时间',
                openbidBegin: '开标时间',
                openbidAddr: '开标地点'
            }
    }
}

/**
 * 是否是谈判/单一
 * @param cgfs
 * @returns {boolean}
 */
export const IsTpOrDyMethod = (cgfs) => {
    return '12,14'.includes(cgfs)
}


/**
 * 跳转项目编辑页面
 * @param openBid 是否系统开标
 * @returns {string|*|string}
 */
const OPEN_BID = '0'
const UN_OPEN_BID = '1'
export const isToBidEditPath = (openBid) => {
    //如果是不使用系统开标则直接跳简易框图
    if (openBid && UN_OPEN_BID === openBid) {
        return '/easybid/easyBidApplyEdit'
    }
    return '/legalApply/edit'
}

/**
 * 是否是公告管理员/系统管理员
 */
export const isAnnounceAdmin = (that) => {
    let user = that.$ls.get('user')
    return !!user.permissions['system.manage'] || !!user.permissions['announce.admin']
}

